 import Vue from 'vue'
 import Highcharts from "highcharts";
 import HighchartsVue from "highcharts-vue";
 import boost from "highcharts/modules/boost";
 import exporting from "highcharts/modules/exporting";
 import data from "highcharts/modules/export-data";

boost(Highcharts);
exporting(Highcharts);
data(Highcharts);

Vue.use(HighchartsVue);
